<template>
  <Report
    v-bind="$attrs"
    :column-defs="columnDefs"
    :default-filter-model="defaultFilterModel"
    retrieve-action="report/retrieveEvents"
    source="events"
    v-on="$listeners"
  />
</template>

<script>
import Report from '@/components/scheduling/reports/Report';
import { dateColumn, namedValues, plainColumn, setColumn, textColumn } from '@/components/scheduling/reports/columns';

// The tokens the event report API filters states by, in the order they're offered.
const EVENT_STATES = ['scheduled', 'pending', 'approved', 'rejected', 'withdrawn', 'expired'];

export default {
  components: {
    Report
  },
  inheritAttrs: false,
  data () {
    return {
      columnDefs: null,
      defaultFilterModel: {
        state: {
          filterType: 'set',
          values: ['scheduled', 'approved']
        }
      }
    };
  },
  created () {
    this.columnDefs = this.buildColumnDefs();
  },
  methods: {
    buildColumnDefs () {
      const t = key => this.$t(key);
      const org = this.$store.state.org;
      const states = EVENT_STATES.map(state => ({ id: state, name: this.$t(`labels.${state}`) }));

      const columnDefs = [
        dateColumn('date', this.$tc('labels.date', 1), t),
        textColumn('assigneeFullName', this.$t('labels.employeeName')),
        plainColumn('employeeId', this.$t('labels.employeeID')),
        plainColumn('homeDepartmentName', this.$t('labels.homeDepartment')),
        setColumn('jobStatusName', this.$t('labels.jobStatus'), namedValues(org.jobStatus)),
        setColumn('jobTypeName', this.$tc('labels.jobType', 1), namedValues(org.jobTypes))
      ];
      if (this.$store.getters['account/isDepartmentManagement']()) {
        columnDefs.push(plainColumn('departmentName', this.$tc('labels.department', 1)));
      } else {
        columnDefs.push(setColumn('departmentName', this.$tc('labels.department', 1), namedValues(org.departments), { sortable: true }));
      }
      columnDefs.push(
        setColumn('typeName', this.$t('labels.eventType'), namedValues(org.eventTypes), { sortable: true }),
        setColumn('state', this.$tc('labels.state', 1), states, { sortable: true, suppressMiniFilter: true })
      );
      return columnDefs;
    }
  }
};
</script>
